import Swiper from 'swiper/bundle';
jQuery(document).ready(function () {
   sliderFromGallery();
   initMobileMenu();
});

function initMobileMenu() {
   $('.menu-toggle').on('click', function() {
      $(this).toggleClass('is-active');
      $('.mobile-menu-overlay').toggleClass('is-active');
      $('body').toggleClass('menu-open');
   });

   $('.mobile-menu-overlay a, .menu-item a').on('click', function() {
      if ($('.mobile-menu-overlay').hasClass('is-active')) {
         $('.menu-toggle').removeClass('is-active');
         $('.mobile-menu-overlay').removeClass('is-active');
         $('body').removeClass('menu-open');
      }
   });
}


function sliderFromGallery() {
   const $galleries = $('.wp-block-gallery');
   if (!$galleries.length) return;

   const leftArrowSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
   const rightArrowSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

   $galleries.each(function() {
      const $gallery = $(this);

      if ($gallery.hasClass('swiper-initialized') || $gallery.closest('.swiper-gallery-wrapper').length) return;

      const $prevArrow = $(`<div class="custom-swiper-arrow custom-prev" role="button" aria-label="Previous slide">${leftArrowSvg}</div>`);
      const $nextArrow = $(`<div class="custom-swiper-arrow custom-next" role="button" aria-label="Next slide">${rightArrowSvg}</div>`);
      const $pagination = $(`<div class="custom-swiper-pagination"></div>`);

      const $images = $gallery.find('.wp-block-image');
      const slideCount = $images.length;

      if (slideCount === 0) return;

      $images.each(function() {
         const $slide = $(this).addClass('swiper-slide');
         const $img = $slide.find('img');
         const src = $img.attr('src');
         const altText = $img.attr('alt');

         $slide.attr('data-src', src);
         $slide.attr('data-caption', altText || '');
         $slide.css('cursor', 'pointer');

         if (altText && altText.trim() !== "" && !$slide.find('.wp-element-caption, figcaption').length) {
            $slide.append(`<div class="wp-element-caption">${altText}</div>`);
         }
      });

      $gallery.wrap('<div class="swiper-gallery-wrapper"></div>');
      const $wrapper = $gallery.parent('.swiper-gallery-wrapper');

      $gallery.addClass('swiper');
      $gallery.wrapInner('<div class="swiper-wrapper"></div>');

      // Always append them, Swiper will handle hiding/disabling them via watchOverflow
      $wrapper.append($prevArrow, $nextArrow, $pagination);

      const shouldLoop = slideCount > 3;

      new Swiper($gallery[0], {
         slidesPerView: 3,
         spaceBetween: 24,
         loop: shouldLoop,
         grabCursor: slideCount > 1,

         // CRITICAL: Automatically disables/hides navigation & pagination
         // when there are not enough slides to scroll
         watchOverflow: true,

         navigation: {
            nextEl: $nextArrow[0],
            prevEl: $prevArrow[0]
         },

         pagination: {
            el: $pagination[0],
            clickable: true
         },

         breakpoints: {
            320: {
               slidesPerView: 1,
               spaceBetween: 12,
               loop: slideCount > 1
            },
            768: {
               slidesPerView: 2,
               spaceBetween: 18,
               loop: slideCount > 2
            },
            1024: {
               slidesPerView: 3,
               spaceBetween: 24,
               loop: shouldLoop
            }
         }
      });
   });

   // Fancybox click event
   if (typeof Fancybox !== 'undefined') {
      $(document).off('click', '.swiper-slide').on('click', '.swiper-slide', function(e) {
         if ($(e.target).closest('a').length) {
            e.preventDefault();
         }

         const $clickedSlide = $(this);
         const initialSrc = $clickedSlide.attr('data-src');

         if (!initialSrc) return;

         const $currentGallery = $clickedSlide.closest('.wp-block-gallery');
         const slidesArray = [];
         let startIndex = 0;

         const $validSlides = $currentGallery.find('.swiper-slide:not(.swiper-slide-duplicate)');

         $validSlides.each(function(index) {
            const src = $(this).attr('data-src');
            const caption = $(this).attr('data-caption');

            slidesArray.push({
               src: src,
               caption: caption
            });

            if (src === initialSrc) {
               startIndex = index;
            }
         });

         Fancybox.show(slidesArray, {
            startIndex: startIndex
         });
      });
   }
}